// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const View: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 52 31" enableBackground="new 0 0 52 31" xmlSpace="preserve">
<g>
	<path d="M50.95,15.5c0.02-0.03,0.04-0.06,0.05-0.08l-0.16-0.1l-0.3-0.49C45.22,6.32,35.82,1,25.5,1C14.98,1,5.44,6.52,0.17,15.31
		L0,15.41l0.05,0.09C0.04,15.53,0.02,15.56,0,15.59l0.16,0.1l0.3,0.49C5.78,24.68,15.18,30,25.5,30c10.52,0,20.06-5.52,25.33-14.31
		l0.17-0.1L50.95,15.5z M25.5,27.22c-9.04,0-17.28-4.48-22.18-11.71C8.22,8.27,16.46,3.78,25.5,3.78c9.04,0,17.28,4.48,22.18,11.71
		C42.78,22.73,34.54,27.22,25.5,27.22z"/>
	<path d="M25.63,6.04c-5.4,0-9.78,4.23-9.78,9.46c0,5.23,4.39,9.46,9.78,9.46c5.4,0,9.78-4.23,9.78-9.46
		C35.42,10.27,31.03,6.04,25.63,6.04z M25.63,22.35c-3.97,0-7.17-3.07-7.17-6.85c0-3.77,3.21-6.85,7.17-6.85
		c3.97,0,7.17,3.07,7.17,6.85C32.81,19.28,29.6,22.35,25.63,22.35z"/>
</g>
</svg>;
};

export default React.memo(View);
